module.exports = __webpack_public_path__ + "img/6.f4c4bfa7.png";